import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Servicesbanner from '../Servicesbanner';
import { IconArrowUpRight } from '@tabler/icons-react';

const Services = () => {
  return (
    <>  
      <Servicesbanner 
        highlight="Services" 
      />
      <section className='services-main'>
        <Container>
          <Row>
            <Col md={12}>
              <div className="head-title">
                <div className="sup">Services</div>
                <h2>Our Best <span className='text-gradient'>Services</span></h2>
              </div>
            </Col>
          </Row>
          <Row className='justify-content-between'>
            <Col md={6} className='mb-4'>
              <Link to="/effortlessglobalpayments" className="box">
                <div className="img-box">
                  <img src="../Images/effortless-global-payments.png" alt="" />
                </div>
                <div className="cont">
                  <h3>Effortless Global Payments</h3>
                  <p>Send money worldwide in major currencies like USD, CNY, CAD, EUR, NGN, GBP and more with fast, reliable, and cost-effective transfers. </p>
                  <p>Perfect for business, tuition, or family support, with competitive rates and no hidden fees.</p>
                </div>
                <div className="btn-box">
                  <button as={Link} to="/effortlessglobalpayments" className='button yellow rounded-pill'><IconArrowUpRight size={30} stroke={2} /></button>
                </div>
              </Link>
            </Col>
            <Col md={6} className='mb-4'>
              <Link to="/applyforletterofcredit" className="box">
                <div className="img-box">
                  <img src="../Images/apply-for-letter-of-credit.png" alt="" />
                </div>
                <div className="cont">
                  <h3>Apply for Letter of Credit (LC)</h3>
                  <p>Navigating international trade requires the right financial guarantees. At MyFX.ca, we specialize in Letter of Credit (LC) issuance to help importers and businesses secure international deals.</p>
                </div>
                <div className="btn-box">
                  <button as={Link} to="/applyforletterofcredit" className='button yellow rounded-pill'><IconArrowUpRight size={30} stroke={2} /></button>
                </div>
              </Link>
            </Col>
            <Col md={6} className='mb-4'>
              <Link to="/tuitionpaymentsforcanada" className="box">
                <div className="img-box">
                  <img src="../Images/tuition-payments-for-canada.png" alt="" />
                </div>
                <div className="cont">
                  <h3>Tuition Payments for Canada</h3>
                  <p>Our tuition payments for canada service ensures secure, efficient, and timely transfers to Canadian institutions. Enjoy competitive exchange rates, transparent fees, and quick processing.</p>
                  <p>Simplify international tuition payments with our cost-effective solution.</p>
                </div>
                <div className="btn-box">
                  <button as={Link} to="/tuitionpaymentsforcanada" className='button yellow rounded-pill'><IconArrowUpRight size={30} stroke={2} /></button>
                </div>
              </Link>
            </Col>
            <Col md={6} className='mb-4'>
              <Link to="/realestateinvestmentpayments" className="box">
                <div className="img-box">
                  <img src="../Images/real-estate-payments.png" alt="" />
                </div>
                <div className="cont">
                  <h3>Real Estate Investment Payments</h3>
                  <p>Our real estate investment payments service offers secure, efficient fund transfers for property transactions in Canada and internationally. We handle currency conversion, payment processing, and documentation with competitive rates and transparent fees. Invest across borders confidently with our compliant, streamlined solution.</p>
                </div>
                <div className="btn-box">
                  <button as={Link} to="/realestateinvestmentpayments" className='button yellow rounded-pill'><IconArrowUpRight size={30} stroke={2} /></button>
                </div>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Services